import { useFetch } from 'app/queryProvider';
import type { IPaginatedResponse } from '@shared/types/pagination';
import { DOCUMENTS_PER_PAGE } from '../constants';
import type { TUseAllPagesParams, TUseAllPagesResult } from '../types';
import { hasMoreThanLoaded } from '../utils/documentsQuery';

export const useAllPages = <T>({
    buildUrl,
    queryKey,
    resource,
    enabled,
}: TUseAllPagesParams): TUseAllPagesResult<T> => {
    const first = useFetch<IPaginatedResponse<T>>({
        url: buildUrl(DOCUMENTS_PER_PAGE),
        queryKey: [queryKey],
        resource,
        options: { enabled },
    });

    const loaded = first.data?.results ?? [];
    const total = first.data?.total;
    const hasMore = hasMoreThanLoaded(total, loaded.length);

    const all = useFetch<IPaginatedResponse<T>>({
        url: buildUrl(total ?? DOCUMENTS_PER_PAGE),
        queryKey: [[...queryKey, 'all', String(total ?? 0)]],
        resource,
        options: { enabled: enabled && hasMore },
    });

    return {
        items: hasMore && all.data ? all.data.results : loaded,
        isLoading: first.isLoading || (hasMore && all.isLoading),
        isRefetching: first.isRefetching || all.isRefetching,
        refetch: () => {
            first.refetch();
            if (hasMore) all.refetch();
        },
    };
};
